import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { RiLogoutBoxRFill } from "react-icons/ri"
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./actions/auth.js";
import { Col, Container, Image } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";


const Nav = styled.div`
background: #15171c;
height: 50px;
display: flex;
justify-content: flex-start;
align-items: center;
`;

const NavIcon = styled(Link)`
margin-left: 0.5rem;
font-size: 2rem;
height: 50px;
width: 50px;
display: flex;
justify-content: flex-start;
align-items: center;
`;

const SidebarNav = styled.nav`
background: #15171c;
width: ${({ sidebar }) => (sidebar ? "250px" : "50px")};
height: ${({ sidebar }) => (sidebar ? "95vh" : "50px")};;
display: flex;
justify-content: ;
position: fixed;
top: 50px;
left: 0;
z-index: 10;
`;

const SidebarWrap = styled.div`
width: 100%;
`;

const Sidebar = (props) => {
	const defaultSidebarStatus = props.sidebarStatus !== undefined ? props.sidebarStatus : true;
	const [sidebar, setSidebar] = useState(defaultSidebarStatus);
	const [useradmin, setUserAdmin] = useState(false);
	const [userb, setUserB] = useState(false);
	const [usera, setUserA] = useState(false);
	//const boxRef = useRef(null);
	//const boxOutsideClick = OutsideClick(boxRef);

	const showSidebar = () => setSidebar(!sidebar);
	const { user: currentUser } = useSelector((state) => state.auth);
	const dispatch = useDispatch();

	useEffect(() => {
		if (currentUser) {
			// these are the role ids from roles table
			setUserAdmin(currentUser.roles.includes(3));
			setUserB(currentUser.roles.includes(1));
			setUserA(currentUser.roles.includes(2));
		}
	}, [currentUser]);
	

	const handleLogout = () => {
		//e.preventDefault();		
		
		dispatch(logout())
		.then(() => {
			//props.history.push("/");
			window.location.reload();
		})
		.catch((e) => {
			console.log(e);
		});
	};	


	return (
		
		<>	
		<IconContext.Provider value={{ color: "white" }}> {/**ref={boxRef} */}
			
			<Container>					
				<SidebarNav sidebar={sidebar} style={{display:"flex", flexDirection:"column", gap:"10px", alignContent:"center", justifyContent:"flex-start"}}>	
					<NavIcon to="#">
						{(sidebar) &&
							<IoMdClose size={20} onClick={showSidebar} />
						}
						{(!sidebar) &&
							<GiHamburgerMenu size={20} onClick={showSidebar} />
						}						
					</NavIcon>					
					
					<Col >
						{(sidebar) &&
						<>
						<Container className="text-center p-2" style={{backgroundColor:'gray'}}>
							<Container className="text-center p-1" style={{backgroundColor:'white',maxWidth:'100px'}}>
								<Image src="../logo192.png" style={{height:"80px",width:'80px'}}/>									
							</Container>						
						</Container>					

						<SidebarWrap>		
							{SidebarData.map((item, index) => {
								return (item.userrole.filter(value => currentUser.roles.includes(value)).length > 0) && <SubMenu currentUser={currentUser} item={item} key={index} />;
							})}			
						</SidebarWrap>
						</>
						}
					</Col>
				</SidebarNav>
			</Container>
		</IconContext.Provider>
		</>
	);
};

export default Sidebar;
